import { render, staticRenderFns } from "./General.vue?vue&type=template&id=012c6d45&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=012c6d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c6d45",
  null
  
)

export default component.exports